import { ReactElement } from 'react';

export enum SocialMediaPlatform {
  Facebook = 'Facebook',
  Instagram = 'Instagram',
  Telegram = 'Telegram',
  X = 'X',
  YouTube = 'YouTube',
}

export type SocialMediaPlatformRecord = Record<
  SocialMediaPlatform,
  {
    icon: ReactElement;
    text: string;
    url: string;
  }
>;
